var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.9791 48.2502C51.4074 48.2502 51.8125 48.0573 52.0822 47.7245C52.3519 47.3918 52.4571 46.9553 52.3686 46.5364L51.4743 42.3042C51.9836 41.8114 52.3038 41.1235 52.3038 40.3586C52.3038 39.5534 51.9452 38.8392 51.3885 38.343V23.6458L47.8035 25.8644V38.343C47.2468 38.8392 46.8881 39.5534 46.8881 40.3586C46.8881 41.1236 47.2084 41.8116 47.7177 42.3042L46.8232 46.5364C46.7348 46.9554 46.8401 47.3918 47.1096 47.7245C47.3793 48.0572 47.7845 48.2502 48.2128 48.2502H50.9791ZM52.1943 15.0694L28.8715 0.631952C28.1885 0.211211 27.4185 0 26.6485 0C25.8785 0 25.108 0.211034 24.4291 0.631952L1.106 15.0694C0.483222 15.4548 0.10498 16.1354 0.10498 16.8679C0.10498 17.6005 0.483222 18.2814 1.106 18.6673L24.429 33.1049C25.1079 33.5261 25.8784 33.7369 26.6484 33.7369C27.4184 33.7369 28.1885 33.5259 28.8714 33.1049L52.1943 18.6673C52.817 18.2816 53.1953 17.6005 53.1953 16.8679C53.1953 16.1354 52.8171 15.4545 52.1943 15.0694ZM26.6484 37.3217C25.1956 37.3217 23.7776 36.9182 22.5417 36.1533L8.93727 27.731V42.2333C8.93727 46.5255 16.8705 50 26.6484 50C36.4297 50 44.3623 46.5254 44.3623 42.2333V27.731L30.7585 36.1533C29.5225 36.9182 28.1012 37.3217 26.6484 37.3217Z",
    fill: "#6C84F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.552e06b1ef0912642bec8cb555be8639.svg";
export { ForwardRef as ReactComponent };